import { render, staticRenderFns } from "./InteractiveFlashCards.vue?vue&type=template&id=7b5b017e&scoped=true&lang=pug&"
import script from "./InteractiveFlashCards.vue?vue&type=script&lang=js&"
export * from "./InteractiveFlashCards.vue?vue&type=script&lang=js&"
import style0 from "./InteractiveFlashCards.vue?vue&type=style&index=0&id=7b5b017e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5b017e",
  null
  
)

export default component.exports